import { ReportRepository } from '../repositories'

export type Category = 'car-records'|'car-infos'|'pio-records'|'employee-records'|'car-statistics';

export interface GetReportParamsBo extends ReportRepository.GetReportReqDto {}

export interface GetCarRecordsRespBo extends ReportRepository.CarRecordsRespDto {}

/** 取得車輛組裝紀錄 */
export async function getCarRecords(params: GetReportParamsBo): Promise<GetCarRecordsRespBo> {
  const itemListDto = await ReportRepository.getCarRecords(params)

  return itemListDto
}

/** 匯出車輛紀錄 */
export async function exportCarRecords(params: GetReportParamsBo): Promise<void> {
  await ReportRepository.exportCarRecords(params)
}

export interface GetCarRecordDetailParamsBo extends ReportRepository.GetCarRecordDetailReqDto {}

export interface GetCarRecordDetailRespBo extends ReportRepository.GetCarRecordDetailRespDto {}

/** 取得車輛紀錄明細 */
export async function getCarRecordDetail(params: GetCarRecordDetailParamsBo): Promise<GetCarRecordDetailRespBo> {
  const detailDto = await ReportRepository.getCarRecordDetail(params)

  return detailDto
}

export interface GetCarInfosRespBo extends ReportRepository.CarInfosRespDto {}

/** 車籍資料 CarInfo */
export async function getCarInfos(params: GetReportParamsBo): Promise<GetCarInfosRespBo> {
  const itemListDto = await ReportRepository.getCarInfos(params)

  return itemListDto
}

/** 匯出車籍資料 */
export async function exportCarInfos(params: GetReportParamsBo): Promise<void> {
  await ReportRepository.exportCarInfos(params)
}

export interface GetCarInfoParamsBo extends ReportRepository.GetCarInfoReqDto {}

export interface GetCarInfoRespBo extends ReportRepository.GetCarInfoRespDto {}

/** 取得單筆車籍資料 */
export async function getCarInfo(params: GetCarInfoParamsBo): Promise<GetCarInfoRespBo> {
  const itemListDto = await ReportRepository.getCarInfo(params)

  return itemListDto
}

export interface UpdateCarInfoParamsBo extends ReportRepository.UpdateCarInfoReqDto {}

/** 更新車籍資料 */
export async function updateCarInfo(params: UpdateCarInfoParamsBo): Promise<void> {
  await ReportRepository.updateCarInfo(params)
}

export interface DeleteCarInfoParamsBo extends ReportRepository.DeleteCarInfoReqDto {}

/** 刪除車籍資料 */
export async function deleteCarInfo(params: DeleteCarInfoParamsBo): Promise<void> {
  await ReportRepository.deleteCarInfo(params)
}

export interface GetPIORecordsRepsBo extends ReportRepository.PIORecordsRespDto {}

/** 項目(PIO)報表 */
export async function getPIORecords(params: GetReportParamsBo): Promise<GetPIORecordsRepsBo> {
  const itemListDto = await ReportRepository.getPIORecords(params)

  return itemListDto
}

/** 匯出項目(PIO)紀錄 */
export async function exportPIORecords(params: GetReportParamsBo): Promise<void> {
  await ReportRepository.exportPIORecords(params)
}

export interface GetPIOItemArgsParamsBo extends ReportRepository.GetPIOItemArgsReqDto {}

export interface GetPIOItemArgsRespBo extends ReportRepository.GetPIOItemArgsRespDto {}

/** 取得PIO項目參數 */
export async function getPIOItemArgs(params: GetPIOItemArgsParamsBo): Promise<GetPIOItemArgsRespBo> {
  const itemListDto = await ReportRepository.getPIOItemArgs(params)

  return itemListDto
}

export interface UpdatePIOItemArgsParamsBo extends ReportRepository.UpdatePIOItemArgsReqDto {}

/** 更新PIO項目參數 */
export async function updatePIOItemArgs(params: UpdatePIOItemArgsParamsBo): Promise<void> {
  await ReportRepository.updatePIOItemArgs(params)
}

export interface GetEmployeeRecordsRespBo extends ReportRepository.EmployeeRecordsRespDto {}

/** 員工紀錄 Employee record */
export async function getEmployeeRecords(params: GetReportParamsBo): Promise<GetEmployeeRecordsRespBo> {
  const itemListDto = await ReportRepository.getEmployeeRecords(params)

  return itemListDto
}

/** 匯出員工紀錄 */
export async function exportEmployeeRecords(params: GetReportParamsBo): Promise<void> {
  await ReportRepository.exportEmployeeRecords(params)
}

export interface GetCarStatisticsRespBo extends ReportRepository.GetCarStatisticsRespDto {}

/** 車輛整體統計 Car Statistics */
export async function getCarStatistics(params: GetReportParamsBo): Promise<GetCarStatisticsRespBo> {
  const itemListDto = await ReportRepository.getCarStatistics(params)

  return itemListDto
}

/** 匯出車輛整體統計 */
export async function exportCarStatistics(params: GetReportParamsBo): Promise<void> {
  await ReportRepository.exportCarStatistics(params)
}

export interface GetTotalOutputRespBo extends ReportRepository.GetTotalOutputRespDto {}

/** 總產量 Total Output */
export async function getTotalOutput(params: GetReportParamsBo): Promise<GetTotalOutputRespBo> {
  const itemListDto = await ReportRepository.getTotalOutput(params)

  return itemListDto
}

/** 匯出總產量 */
export async function exportTotalOutput(params: GetReportParamsBo): Promise<void> {
  await ReportRepository.exportTotalOutput(params)
}